import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DebounceClickDirective } from './debounce-click.directive';


@NgModule({
    imports: [CommonModule],
    exports: [DebounceClickDirective],
    declarations: [DebounceClickDirective],
    providers: [],
})
export class DebounceClickDirectiveModule { }
